export enum Role {
  SubscriptionAdmin = 'SubscriptionAdmin',
  Supporter = 'Supporter',
  GlobalAdmin = 'GlobalAdmin',
}
